import React from 'react';

const Loader = ({ message = 'LOADING' }) => (
  <div className="fs-loader">
    <div className="fs-loader-core">
      <div className="fs-loader-ring" />
      <div className="fs-loader-ring r2" />
      <div className="fs-loader-ring r3" />
      <div className="core-dot" />
      <div className="fs-loader-orbit" />
      <div className="fs-loader-orbit o2" />
    </div>
    <div className="fs-loader-text">
      {message}
      <span className="dots">
        <span>.</span><span>.</span><span>.</span>
      </span>
    </div>
  </div>
);

export default Loader;
